<mat-form-field [attr.data-test-id]="testId"
                class="form-input">
  <input [formControl]="formControl"
         [placeholder]="placeholder"
         [attr.aria-label]="label"
         [maxLength]="maxLength"
         type="text"
         class="input"
         autocomplete="off"
         InputTrim
         matInput>

  <button *ngIf="clearEnabled && building?.value"
          (click)="clearField(building, $event, '')"
          class="p-0"
          mat-button
          matSuffix
          mat-icon-button
          aria-label="Clear">
    <mat-icon class="material-icons_grey-light material-icons_clear">add_circle</mat-icon>
  </button>

  <mat-error>{{getError(building, BuildingErrors)}}</mat-error>
</mat-form-field>
